import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { PublicSwPageNoAuthComponent } from './public-sw-page-noauth.component';

import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { ChartModule } from 'primeng/chart';
import { DropdownModule } from 'primeng/dropdown';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { PanelModule } from 'primeng/panel';

@NgModule({
    declarations: [PublicSwPageNoAuthComponent],
    imports: [
        AccordionModule,
        ButtonModule,
        ChartModule,
        CommonModule,
        DropdownModule,
        FormsModule,
        PanelModule,
        ReactiveFormsModule,
        SharedModule,
    ],
    exports: [
        PublicSwPageNoAuthComponent
    ]
})
export class PublicSwPageNoAuthModule { }
